// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostBanner-container-IAYG1 {
  max-width: var(--max-content-width);
  margin: 0 auto;
  padding: 0 15px;
}

.WhyHostBanner-mainText-yuO_m {
  font-size: 48px;
  font-weight: 600;
  margin: 12px 0px !important;
}

.WhyHostBanner-listText-kQ4vl {
  font-size: 18px;
  margin-bottom: 36px;
}

.WhyHostBanner-listButton-SXEGm,
.WhyHostBanner-listButton-SXEGm:hover,
.WhyHostBanner-listButton-SXEGm:focus {
  -webkit-box-shadow: 0px 21px 41px #31313126 !important;
          box-shadow: 0px 21px 41px #31313126 !important;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  white-space: normal !important;

}

.WhyHostBanner-Banner-PYaX9 {
  background-size: cover;
  background-position: 50%;
  background-color: #F5F8FF;
  height: 100%;
  min-height: 609px;
  border-radius: 12px;
  padding: 30px 83px;
}

.WhyHostBanner-tip-OL9w1 {
  background-color: #CAFFCB;
  border-radius: 17px;
  font-size: 18px;
  color: #128815;
  padding: 5px 22px;
  text-align: center;
  display: table;
  font-weight: 600;

}

.WhyHostBanner-learnIconCss-rM54D {
  width: 17px;
  -webkit-animation: WhyHostBanner-moveUpDown-ZwxGz 0.45s infinite alternate;
  animation: WhyHostBanner-moveUpDown-ZwxGz 0.45s infinite alternate;
}

.WhyHostBanner-whyHostLearMoreBtn-Bi3qg,
.WhyHostBanner-whyHostLearMoreBtn-Bi3qg:hover,
.WhyHostBanner-whyHostLearMoreBtn-Bi3qg:focus,
.WhyHostBanner-whyHostLearMoreBtn-Bi3qg:active,
.WhyHostBanner-whyHostLearMoreBtn-Bi3qg:active:hover {
  background: transparent !important;
  border: 1px solid var(--primary-border) !important;
  color: var(--common-text-color) !important;
  text-decoration: none !important;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  text-align: center;
  white-space: normal;
}

.WhyHostBanner-whyHostLearMoreBtn-Bi3qg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.WhyHostBanner-leftImageCss-gfK2_ {
  width: 100%;

}

.WhyHostBanner-minWidthBanner-sxwRA {
  min-width: 1108px;
}

.WhyHostBanner-whyHostdoubleButton-zYuc2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

@-webkit-keyframes WhyHostBanner-moveUpDown-ZwxGz {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-5px);
            transform: translateY(-5px);
  }
}

@keyframes WhyHostBanner-moveUpDown-ZwxGz {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-5px);
            transform: translateY(-5px);
  }
}

@media screen and (max-width: 1199px) {
  .WhyHostBanner-Banner-PYaX9 {
    padding: 15px;
  }
}

@media screen and (max-width: 991px) {
  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg {
    text-align: center;
    display: block;
  }

  .WhyHostBanner-listButton-SXEGm {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .WhyHostBanner-noflex-r10AB {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .WhyHostBanner-noWrapFlex-ObOtM {
    -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
  }

  .WhyHostBanner-minWidthBanner-sxwRA {
    min-width: 100%;
  }

}

@media screen and (max-width: 767px) {
  .WhyHostBanner-bannerText-kFyLF {
    top: 15%;
  }

  .WhyHostBanner-container-IAYG1 {
    padding: 15px;
  }

  .WhyHostBanner-noflex-r10AB {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg,
  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg:hover,
  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg:focus,
  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg:active,
  .WhyHostBanner-whyHostLearMoreBtn-Bi3qg:active:hover {
    width: 100%;
  }

  .WhyHostBanner-listButton-SXEGm {
    width: 100%;
    -webkit-box-shadow: unset !important;
            box-shadow: unset !important;
  }
}

@media (max-width:450px) {
  .WhyHostBanner-mainText-yuO_m {
    font-size: 45px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/whyhostnew/WhyHostBanner.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,sDAA8C;UAA9C,8CAA8C;EAC9C,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAA8B;;AAEhC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,0EAAsD;EACtD,kEAA8C;AAChD;;AAEA;;;;;EAKE,kCAAkC;EAClC,kDAAkD;EAClD,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;;AAEb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE;IACE,gCAAwB;YAAxB,wBAAwB;EAC1B;;EAEA;IACE,mCAA2B;YAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gCAAwB;YAAxB,wBAAwB;EAC1B;;EAEA;IACE,mCAA2B;YAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,qBAAiB;QAAjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAe;QAAf,eAAe;EACjB;;EAEA;;;;;IAKE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oCAA4B;YAA5B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  max-width: var(--max-content-width);\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.mainText {\n  font-size: 48px;\n  font-weight: 600;\n  margin: 12px 0px !important;\n}\n\n.listText {\n  font-size: 18px;\n  margin-bottom: 36px;\n}\n\n.listButton,\n.listButton:hover,\n.listButton:focus {\n  box-shadow: 0px 21px 41px #31313126 !important;\n  display: inline-flex;\n  align-items: center;\n  white-space: normal !important;\n\n}\n\n.Banner {\n  background-size: cover;\n  background-position: 50%;\n  background-color: #F5F8FF;\n  height: 100%;\n  min-height: 609px;\n  border-radius: 12px;\n  padding: 30px 83px;\n}\n\n.tip {\n  background-color: #CAFFCB;\n  border-radius: 17px;\n  font-size: 18px;\n  color: #128815;\n  padding: 5px 22px;\n  text-align: center;\n  display: table;\n  font-weight: 600;\n\n}\n\n.learnIconCss {\n  width: 17px;\n  -webkit-animation: moveUpDown 0.45s infinite alternate;\n  animation: moveUpDown 0.45s infinite alternate;\n}\n\n.whyHostLearMoreBtn,\n.whyHostLearMoreBtn:hover,\n.whyHostLearMoreBtn:focus,\n.whyHostLearMoreBtn:active,\n.whyHostLearMoreBtn:active:hover {\n  background: transparent !important;\n  border: 1px solid var(--primary-border) !important;\n  color: var(--common-text-color) !important;\n  text-decoration: none !important;\n  border-radius: 6px;\n  padding: 10px 20px;\n  cursor: pointer;\n  text-align: center;\n  white-space: normal;\n}\n\n.whyHostLearMoreBtn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.leftImageCss {\n  width: 100%;\n\n}\n\n.minWidthBanner {\n  min-width: 1108px;\n}\n\n.whyHostdoubleButton {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n@-webkit-keyframes moveUpDown {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes moveUpDown {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-5px);\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .Banner {\n    padding: 15px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .whyHostLearMoreBtn {\n    text-align: center;\n    display: block;\n  }\n\n  .listButton {\n    justify-content: center;\n  }\n\n  .noflex {\n    flex-wrap: wrap;\n  }\n\n  .noWrapFlex {\n    flex-wrap: nowrap;\n  }\n\n  .minWidthBanner {\n    min-width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 767px) {\n  .bannerText {\n    top: 15%;\n  }\n\n  .container {\n    padding: 15px;\n  }\n\n  .noflex {\n    flex-wrap: wrap;\n  }\n\n  .whyHostLearMoreBtn,\n  .whyHostLearMoreBtn:hover,\n  .whyHostLearMoreBtn:focus,\n  .whyHostLearMoreBtn:active,\n  .whyHostLearMoreBtn:active:hover {\n    width: 100%;\n  }\n\n  .listButton {\n    width: 100%;\n    box-shadow: unset !important;\n  }\n}\n\n@media (max-width:450px) {\n  .mainText {\n    font-size: 45px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WhyHostBanner-container-IAYG1`,
	"mainText": `WhyHostBanner-mainText-yuO_m`,
	"listText": `WhyHostBanner-listText-kQ4vl`,
	"listButton": `WhyHostBanner-listButton-SXEGm`,
	"Banner": `WhyHostBanner-Banner-PYaX9`,
	"tip": `WhyHostBanner-tip-OL9w1`,
	"learnIconCss": `WhyHostBanner-learnIconCss-rM54D`,
	"moveUpDown": `WhyHostBanner-moveUpDown-ZwxGz`,
	"whyHostLearMoreBtn": `WhyHostBanner-whyHostLearMoreBtn-Bi3qg`,
	"leftImageCss": `WhyHostBanner-leftImageCss-gfK2_`,
	"minWidthBanner": `WhyHostBanner-minWidthBanner-sxwRA`,
	"whyHostdoubleButton": `WhyHostBanner-whyHostdoubleButton-zYuc2`,
	"noflex": `WhyHostBanner-noflex-r10AB`,
	"noWrapFlex": `WhyHostBanner-noWrapFlex-ObOtM`,
	"bannerText": `WhyHostBanner-bannerText-kFyLF`
};
module.exports = ___CSS_LOADER_EXPORT___;
